import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  readonly fileBrowserView = 'fileBrowserView';
  readonly sortingDevices = 'sortingDevices';
  readonly grouping = 'grouping';
  readonly sortFilesType = 'sortFilesType';
  readonly sortDirectionFiles = 'sortDirectionFiles';
  readonly idLanguage = 'idLanguage';
  readonly sideMenu = 'sideMenu';
  readonly lpLanguage = 'lpLanguage';
  readonly filteringDevices = 'filteringDevices';
  static readonly userTheme = 'userTheme';
  static parsingFileName(deviceId: string) {
    return `${deviceId}-parsingFileName`;
  }

  getStorage = (key: string): any => {
    return localStorage.getItem(key);
  };

  setStorage = (value: string, key: string): void => {
    localStorage.setItem(key, value);
  };

  clearStorage = (): void => {
    localStorage.removeItem(this.fileBrowserView);
    localStorage.removeItem(this.sortingDevices);
    localStorage.removeItem(this.grouping);
    localStorage.removeItem(this.sortDirectionFiles);
    localStorage.removeItem(this.sortFilesType);
    localStorage.removeItem(this.idLanguage);
    localStorage.removeItem(this.sideMenu);
    localStorage.removeItem(this.filteringDevices);
  };

  setSessionStorage(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  getSessionStorage(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  removeSessionStorage(key: string) {
    sessionStorage.removeItem(key);
  }

  clearSessionStorage(): void {
    sessionStorage.clear();
  }
}
